import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

// Remove Markdown bold markers (e.g. "**Pris:**") that some older / auto
// generated descriptions stored as literal text. We render plain text, so
// the asterisks should never be shown to the user.
const stripMarkdown = str =>
  typeof str === 'string' ? str.replace(/\*\*(.*?)\*\*/g, '$1').replace(/\*\*/g, '') : str;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;

  // Split on newlines so line breaks in the stored description are preserved
  // regardless of the CSS white-space value. Each line is still passed through
  // richText for link detection and long-word wrapping.
  const lines = typeof text === 'string' ? stripMarkdown(text).split('\n') : [];
  const content = lines.map((line, i) => (
    <React.Fragment key={i}>
      {i > 0 ? <br /> : null}
      {richText(line, {
        linkify: true,
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
        longWordClass: css.longWord,
        breakChars: '/',
      })}
    </React.Fragment>
  ));

  return text ? (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>{content}</p>
    </section>
  ) : null;
};

export default SectionTextMaybe;
